import React from "react";
import { BackgroundImage } from "./BackgroundImage";
import Header from "./Header";
import SearchBar from "./SearchBar";
import MovieDetail from "./MovieDetail";
import SearchResults from "./SearchResults";

const GPTSearch = () => {
  return (
    <div className="">
      <BackgroundImage />
      <Header />
      <div className="absolute w-full top-1/4">
        <SearchBar />
        <SearchResults />
      </div>
    </div>
  );
};

export default GPTSearch;
